// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lawyer_disclaimer-module__text--6W0gG{margin-bottom:15px}@media screen and (max-width: 62.5625em){.lawyer_disclaimer-module__text--6W0gG{padding:0px 10px}}\n", ""]);
// Exports
exports.locals = {
	"text": "lawyer_disclaimer-module__text--6W0gG"
};
module.exports = exports;
